import { render, staticRenderFns } from "./solutions.vue?vue&type=template&id=69714063"
import script from "./solutions.vue?vue&type=script&lang=js"
export * from "./solutions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports